import {Record as record} from 'immutable';

export default record(
    {
        byOwnerProperties: [],
        byOwnerPropertiesFetchFailed: false,
        byOwnerPropertiesFetchSuccess: false,
        recommendedProperties: [],
        recommendedPropertiesFetchSuccess: false,
        recommendedPropertiesFetchFailed: false,
        recommendedPropertiesIsFetching: false,
        inquiryProperties: [],
        inquiryPropertiesFetchSuccess: false,
        inquiryPropertiesFetchFailed: false,
        propertyContentItems: [],
        registrationNumber: '',
        unitSpaces: {},
        unitContentItems: [],
        unitMetadata: [],
        urgencyMessage: null,
        discoveryFeed: {},
        rankedBadges: [],
        pricingBadges: [],
        superlativeBadges: [],
        geoRelativeDistances: null,
        description: null,
        localizedPropertyDescriptionMap: {},
        vtHelpfulnessHistory: {}
    },
    'listingExtended'
);
